export default "__VITE_ASSET__ea4cef95__"